import ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import datapoints from '../datapoints';
import { action } from 'satcheljs/lib/legacy';
import { ClientItem, mailStore } from 'owa-mail-store';
import { lazyTranslateText } from 'owa-translation';
import { trace } from 'owa-trace';

export default action('translateItem', datapoints.InlineTranslationMessageTranslated)(
    async function translateItem(itemId: string, subject: string) {
        const item: ClientItem = mailStore.items.get(itemId);
        const translateText = await lazyTranslateText.import();

        const conversationItemParts: ConversationItemParts = mailStore.conversations.get(
            item.ConversationId.Id
        );

        if (conversationItemParts.subjectTranslationData.translationText == null) {
            let translatedSubjectText = null;
            try {
                translatedSubjectText = await translateText(subject);
            } catch (error) {
                handleTranslationError(error);
            }
            if (translatedSubjectText != null) {
                conversationItemParts.subjectTranslationData.translationText = translatedSubjectText;
            }
        }

        if (item.TranslationData.translationText == null) {
            // first time this is run for a message we call OGMA service to get translation
            let translatedText = null;
            try {
                translatedText = await translateText(item.UniqueBody.Value);
            } catch (error) {
                handleTranslationError(error);
            }
            if (translatedText != null) {
                item.TranslationData.translationText = translatedText;
            }
        }

        if (
            item.TranslationData.translationText != null &&
            conversationItemParts.subjectTranslationData.translationText != null
        ) {
            item.TranslationData.isShowingTranslation = true;
            conversationItemParts.subjectTranslationData.isShowingTranslation = true;
        }
    }
);

function handleTranslationError(err: string) {
    // TODO: VSO:2686876 feature work to present errors to user through infobar
    trace.warn('InlineTranslation: Error: ' + err);
}
